import { postWrapper, deleteWrapper } from "../../../utils/fetchWrapper";

const documentService = () => {
  const uploadDocument = async (data) => {
    const url = 'api/documents';
    const json = await postWrapper({ url, data });
    return json;
  }

  const deleteDocument = async (id) => {
    await deleteWrapper({ url: `api/documents/${id}` });
  }

  return {
    uploadDocument,
    deleteDocument
  }
}

const mockDocumentService = () => {
  const uploadDocument = async (body) => {
    return { id: 1, ...body };
  }
  const deleteDocument = () => { }

  return {
    uploadDocument,
    deleteDocument
  }
}

export default documentService;
export { mockDocumentService };
